export default {
  typeMessage: 'Escribir mensaje...',
  send: 'Enviar',
};
